import React from "react";
import Contact from "../../../components/forms/productForms/contact/contact";

export default function ThreePageForm() {
  return <Contact />;
}
